import { render, staticRenderFns } from "./InternalInformation.vue?vue&type=template&id=a4dc0d9a"
import script from "./InternalInformation.vue?vue&type=script&lang=js"
export * from "./InternalInformation.vue?vue&type=script&lang=js"
import style0 from "./InternalInformation.vue?vue&type=style&index=0&id=a4dc0d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports